<template>
  <div>
    <!-- Edit -->
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      :visible="visible"
      :title="`Add / Update marks for ${subjectData ? subjectData.subject.name : ''} (${subjectData ? subjectData.subject.abbreviation : ''})`"
      onOk="handleOk"
      @cancel="handleCancel"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update Mark</a-button>
      </template>
      <a-spin :spinning="spinning">
        <p class="text-muted mb-4">Enter the marks corresponding to the roll nos.</p>
        <a-form class="mb-4" :form="form">
          <div class="row neo-exam-mark-form-table-container" v-if="examData">
            <div class="col-6 col-md-4 col-lg-3" v-for="student_enrollment in examData.students" :key="student_enrollment.id">
              <table class="table table-bordered table-sm-responsive">
                <tbody>
                  <tr>
                    <th scope="row" style="min-width:45px;">
                      {{ student_enrollment.roll_no }}
                    </th>
                    <td>
                      <a-form-item class="d-none">
                        <a-input
                          v-decorator="[`enroll_mark[${student_enrollment.id}][enrollment_id]`, { initialValue: student_enrollment.id }]"
                        />
                      </a-form-item>
                      <a-form-item class="m-0">
                        <!-- for Total in mark subject -->
                        <a-input-number
                          v-if="subjectData.is_in_total === 1"
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][exam_mark_score]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="false"
                          style="width: 100%;"
                        />
                        <!-- for grade only subject -->
                        <a-input v-if="subjectData.grades_only === 1"
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][exam_mark_score]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="false"
                          style="width: 100%;"
                        />
                      </a-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { makeFieldsData } from '../fields'
import { mapState } from 'vuex'

export default {
  name: 'ClassExamMarksForm',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      subjectData: null,
      examData: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openClassExamMarksForm', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
    examSubjects: function () {
      return this.examData.class_section_exam_subject
    },
  },
  methods: {
    showModal: function(subject, exam, studentsData) {
      this.visible = true
      this.subjectData = subject
      this.examData = exam

      this.$nextTick(() => {
        const fieldsData = makeFieldsData(studentsData)
        this.form.setFieldsValue(fieldsData)
      })
    },
    handleSubmit: function (e) {
      // this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              // values.class_section_exam_id = this.examData.id
              // values.subject_id = this.subjectData.id
              let formData = {}

              formData.class_section_exam_id = this.examData.id
              formData.subject_id = this.subjectData.subject.id

              formData.enroll_mark = values.enroll_mark.flat().filter(element => {
                if (element) {
                  return true
                } else {
                  return false
                }
              }).map(el => {
                if (!el.hasOwnProperty('exam_mark_score')) {
                  el.exam_mark_score = null
                }
                // if (el.exam_mark_score === null) {
                //   el.exam_mark_score = null
                // }

                return el
              })
              this.$http
                .post('/api/studentexammark', formData)
                .then(() => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: 'Subject marks updated successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
